import styled from "styled-components";
import { setFlex, setPosition } from "../../variables/Position";
import { BREAKPOINTS } from "../../variables/Breakpoints";

export const HeadlineContainer = styled.div`
  ${setFlex({ direction: "column" })};
  height: fit-content;
  width: 100%;
`;

export const ImageContainer = styled.div`
  height: inherit;
  width: auto;
`;

export const Image = styled.img`
  height: inherit;
  width: inherit;
  width: 35vw;
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    width: 25vw;
  }
`;

export const GifWrapper = styled.div`
  ${setPosition({ position: "relative" })};
`;

export const GifContainer = styled.div`
  ${setPosition({ position: "absolute", top: "0", right: "0" })};
  height: auto;
`;
